const PATHS = {
  HOME: '/',
  PAGES: {
    NEW: '/pages/new',
    EDIT: '/pages/edit',
  },
  STATISTICS: {
    INDEX: '/statistics',
  },
  BADGES: {
    INDEX: '/badges',
  },
  AUTH: {
    INDEX: '/auth/',
    SIGN_IN: '/auth/sign-in',
    SIGN_UP: '/auth/sign-up',
    RESET_PASSWORD: '/auth/reset-password',
  },
  USER_PROFILE: {
    INDEX: '/profile',
  },
  FAQ: {
    ROOT: 'https://morningpages.app/faq',
    LANGUAGE_SUPPORT: 'https://morningpages.app/faq#faq-language-support',
    INSIGHTS: 'https://morningpages.app/faq#faq-insights',
  },
  TERMS_AND_CONDITIONS: 'https://morningpages.app/terms-and-conditions',
  CONTACT_US: 'https://morningpages.app/contact-us',
};

export const IOSAppPath = 'https://itunes.apple.com/us/app/morningpages-daily-journal/id1223874080?mt=8';

export default PATHS;



// WEBPACK FOOTER //
// ./src/constants/paths.ts